/**
 * Multi-game storefront switcher — auto-discovers games from grid sections on the page,
 * sets <html data-active-game> + localStorage, toggles section visibility.
 */
(function () {
  var DEFAULT_KEY = 'mogo-tycoon:active-game';

  function safeJsonParse(text, label) {
    try {
      return JSON.parse(text);
    } catch (e) {
      console.warn('[game-switcher] invalid JSON (' + label + ')', e);
      return null;
    }
  }

  function shopifyRootUrl() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return String(window.Shopify.routes.root);
    }
    return '/';
  }

  function collectionUrlFromHandle(handle) {
    var h = (handle || '').trim();
    if (!h) return '';
    var base = shopifyRootUrl().replace(/\/?$/, '/');
    return base + 'collections/' + h;
  }

  /** Scan homepage/collection grid sections for game metadata. */
  function discoverGamesFromPage() {
    var seen = {};
    var games = [];
    var colMap = {};

    document.querySelectorAll('.shopify-section').forEach(function (sec) {
      var root =
        sec.querySelector('[data-game-cat-root][data-game-id]') ||
        sec.querySelector('[data-mogo-cat-root][data-game-id]') ||
        sec.querySelector('[data-game-id]');
      if (!root) return;

      var id = (root.getAttribute('data-game-id') || '').trim();
      if (!id || seen[id]) return;
      seen[id] = true;

      var label = (root.getAttribute('data-game-label') || '').trim() || id;
      var iconUrl = (root.getAttribute('data-game-icon-url') || '').trim() || null;
      var colUrl = (root.getAttribute('data-game-collection-url') || '').trim();
      var colHandle = (root.getAttribute('data-game-collection-handle') || '').trim() || id;
      if (!colUrl) colUrl = collectionUrlFromHandle(colHandle);

      games.push({
        gameId: id,
        label: label,
        iconUrl: iconUrl,
        collectionUrl: colUrl,
      });
      if (colUrl) colMap[id] = colUrl;
    });

    return { games: games, collectionsByGameId: colMap };
  }

  function uniqueGameIdsFromDom() {
    return discoverGamesFromPage().games.map(function (g) {
      return g.gameId;
    });
  }

  function sanitizeLabel(text) {
    var s = String(text || '')
      .replace(/<!--[\s\S]*?-->/g, '')
      .replace(/\s+/g, ' ')
      .trim();
    return s;
  }

  function mergeGameLists(configGames, discoveredGames) {
    var byId = {};
    var order = [];

    function add(g, preferLabel) {
      if (!g || !g.gameId) return;
      var id = String(g.gameId).trim();
      if (!id) return;
      var label = sanitizeLabel(g.label) || id;
      if (!byId[id]) {
        byId[id] = { gameId: id, label: label, iconUrl: g.iconUrl || null };
        order.push(id);
      } else {
        if (preferLabel && label) byId[id].label = label;
        if (g.iconUrl) byId[id].iconUrl = g.iconUrl;
      }
    }

    /* Grid sections on the page are the source of truth for names. */
    (Array.isArray(discoveredGames) ? discoveredGames : []).forEach(function (g) {
      add(g, true);
    });
    (Array.isArray(configGames) ? configGames : []).forEach(function (g) {
      add(g, false);
    });

    return order.map(function (id) {
      return byId[id];
    });
  }

  function mergeCollectionMaps(a, b) {
    var out = Object.assign({}, a && typeof a === 'object' ? a : {});
    if (b && typeof b === 'object') Object.assign(out, b);
    return out;
  }

  function resolveCollectionUrl(gid, colMap, btn) {
    var id = (gid || '').trim();
    if (!id) return '';
    var map =
      colMap && typeof colMap === 'object' && !Array.isArray(colMap) ? colMap : {};
    if (map[id]) return String(map[id]).trim();
    if (btn) {
      var fromBtn = (btn.getAttribute('data-game-collection-url') || '').trim();
      if (fromBtn) return fromBtn;
    }
    return collectionUrlFromHandle(id);
  }

  function stampCollectionUrlOnOption(btn, url) {
    var u = (url || '').trim();
    if (!btn || !u) return;
    btn.setAttribute('data-game-collection-url', u);
  }

  function findGameMeta(games, id) {
    if (!Array.isArray(games)) return null;
    for (var i = 0; i < games.length; i++) {
      if (games[i] && String(games[i].gameId) === id) return games[i];
    }
    return null;
  }

  var designPreviewGame = null;

  function isThemeEditor() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  function resetDesignPreview() {
    designPreviewGame = null;
    applyGameVisibility((document.documentElement.getAttribute('data-active-game') || '').trim());
  }

  function applyGameVisibility(activeId) {
    /* In Customize, show every grid until the merchant picks a game in the switcher. */
    if (isThemeEditor() && !designPreviewGame) {
      document.querySelectorAll('.shopify-section').forEach(function (sec) {
        sec.classList.remove('game-storefront--inactive');
      });
      return;
    }

    var active = (isThemeEditor() && designPreviewGame ? designPreviewGame : activeId || '').trim();

    /* Guard: never hide every grid. If no grid section matches the active game
       (misconfigured/empty game), fall back to the first game present in the DOM
       so the page is never left blank (just reviews/footer). */
    if (active) {
      var domIds = uniqueGameIdsFromDom();
      if (domIds.length && domIds.indexOf(active) < 0) {
        active = domIds[0];
      }
    }

    document.querySelectorAll('.shopify-section').forEach(function (sec) {
      var root =
        sec.querySelector('[data-game-cat-root][data-game-id]') ||
        sec.querySelector('[data-mogo-cat-root][data-game-id]');
      if (!root) {
        sec.classList.remove('game-storefront--inactive');
        return;
      }
      var gid = (root.getAttribute('data-game-id') || '').trim();
      if (!active) {
        sec.classList.remove('game-storefront--inactive');
        return;
      }
      sec.classList.toggle('game-storefront--inactive', gid !== active);
    });
  }

  function setActiveOnDocument(id, storageKey) {
    document.documentElement.setAttribute('data-active-game', id);
    try {
      localStorage.setItem(storageKey, id);
    } catch (e) {}
    applyGameVisibility(id);
    document.dispatchEvent(new CustomEvent('gameSwitcherActiveChange'));
  }

  /**
   * Only grid sections on this page count for show/hide — header blocks alone must not
   * activate a game with no matching section (that hides every grid → blank page).
   */
  function reconcile(storageKey, defaultGame) {
    var domIds = uniqueGameIdsFromDom();
    if (!domIds.length) return;

    var cur = (document.documentElement.getAttribute('data-active-game') || '').trim();
    var def = defaultGame != null ? String(defaultGame).trim() : '';

    if (cur && domIds.indexOf(cur) >= 0) {
      applyGameVisibility(cur);
      return;
    }

    var pick = def && domIds.indexOf(def) >= 0 ? def : domIds[0];
    setActiveOnDocument(pick, storageKey);
    if (cur) {
      console.info('[game-switcher] no grid for saved game; showing', pick);
    }
  }

  function labelForGame(games, activeId, root) {
    var meta = findGameMeta(games, activeId);
    var label = meta && meta.label ? sanitizeLabel(meta.label) : '';
    if (!label && root) {
      var btn = root.querySelector('[data-game-switcher-pick="' + activeId + '"]');
      if (btn) label = sanitizeLabel(btn.getAttribute('data-game-switcher-label') || '');
    }
    return label || activeId;
  }

  function updatePill(summary, activeId, games, root) {
    var labelEl = summary.querySelector('[data-game-switcher-current]');
    var iconWrap = summary.querySelector('[data-game-switcher-icon]');
    var label = labelForGame(games, activeId, root);
    if (labelEl) labelEl.textContent = label;

    var meta = findGameMeta(games, activeId);

    if (iconWrap) {
      iconWrap.innerHTML = '';
      if (meta && meta.iconUrl) {
        var img = document.createElement('img');
        img.className = 'game-switcher__icon-img';
        img.src = meta.iconUrl;
        img.alt = '';
        img.width = 28;
        img.height = 28;
        img.loading = 'lazy';
        iconWrap.appendChild(img);
      }
    }
  }

  function syncOptions(root, activeId) {
    root.querySelectorAll('[data-game-switcher-pick][role="option"]').forEach(function (btn) {
      var gid = (btn.getAttribute('data-game-switcher-pick') || '').trim();
      btn.setAttribute('aria-selected', gid === activeId ? 'true' : 'false');
    });
  }

  function ensureSwitcherOptions(root, games) {
    var panel = root.querySelector('.game-switcher__panel');
    if (!panel || !Array.isArray(games)) return;

    var existing = {};
    panel.querySelectorAll('[data-game-switcher-pick]').forEach(function (btn) {
      existing[(btn.getAttribute('data-game-switcher-pick') || '').trim()] = true;
    });

    games.forEach(function (g) {
      if (!g || !g.gameId || existing[g.gameId]) return;
      existing[g.gameId] = true;

      var colUrl = (g.collectionUrl || '').trim() || collectionUrlFromHandle(g.gameId);

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'game-switcher__option';
      btn.setAttribute('role', 'option');
      btn.setAttribute('data-game-switcher-pick', g.gameId);
      btn.setAttribute('data-game-switcher-label', g.label || g.gameId);
      if (g.iconUrl) btn.setAttribute('data-game-switcher-icon-url', g.iconUrl);
      stampCollectionUrlOnOption(btn, colUrl);
      btn.setAttribute('aria-selected', 'false');

      if (g.iconUrl) {
        var img = document.createElement('img');
        img.className = 'game-switcher__option-icon';
        img.src = g.iconUrl;
        img.alt = '';
        img.width = 28;
        img.height = 28;
        img.loading = 'lazy';
        btn.appendChild(img);
      }

      var span = document.createElement('span');
      span.textContent = sanitizeLabel(g.label) || g.gameId;
      btn.appendChild(span);

      var wrap = document.createElement('div');
      wrap.className = 'game-switcher__option-wrap';
      wrap.appendChild(btn);
      panel.appendChild(wrap);
    });
  }

  function closeDetails(root) {
    var d = root.querySelector('.game-switcher__details');
    if (!d) return;
    d.removeAttribute('open');
    var s = d.querySelector('summary');
    if (s) s.setAttribute('aria-expanded', 'false');
  }

  function initRoot(root, config) {
    if (!config) return;

    var storageKey = config.storageKey ? String(config.storageKey) : DEFAULT_KEY;
    var games = Array.isArray(config.games) ? config.games : [];

    var details = root.querySelector('.game-switcher__details');
    var summary = details ? details.querySelector('summary') : null;
    var panel = root.querySelector('.game-switcher__panel');

    ensureSwitcherOptions(root, games);

    var colMap =
      config.collectionsByGameId && typeof config.collectionsByGameId === 'object'
        ? config.collectionsByGameId
        : {};
    root.querySelectorAll('[data-game-switcher-pick]').forEach(function (btn) {
      var gid = (btn.getAttribute('data-game-switcher-pick') || '').trim();
      if (!gid) return;
      stampCollectionUrlOnOption(btn, resolveCollectionUrl(gid, colMap, btn));
    });

    function readActiveId() {
      return (document.documentElement.getAttribute('data-active-game') || '').trim();
    }

    function applyUi() {
      var id = readActiveId();
      if (!id) return;
      if (summary) updatePill(summary, id, games, root);
      syncOptions(root, id);
      applyGameVisibility(id);
    }

    if (details) {
      details.addEventListener('toggle', function () {
        var open = details.hasAttribute('open');
        if (summary) summary.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          document.querySelectorAll('.game-switcher__details[open]').forEach(function (other) {
            if (other !== details) {
              other.removeAttribute('open');
              var os = other.querySelector('summary');
              if (os) os.setAttribute('aria-expanded', 'false');
            }
          });
        }
      });
    }

    if (panel) {
      panel.addEventListener('click', function (e) {
        var btn = e.target && e.target.closest ? e.target.closest('[data-game-switcher-pick]') : null;
        if (!btn || !root.contains(btn)) return;
        e.preventDefault();
        var gid = (btn.getAttribute('data-game-switcher-pick') || '').trim();
        if (!gid) return;

        closeDetails(root);
        document.querySelectorAll('.gs--in-header details[open]').forEach(function (d) {
          d.removeAttribute('open');
        });

        var path = window.location.pathname || '';
        var isHomepage =
          path === '/' ||
          path === '' ||
          /^\/$/.test(path) ||
          document.body.classList.contains('template-index');
        var onCollections = path.indexOf('/collections/') >= 0;

        var colMap =
          config.collectionsByGameId && typeof config.collectionsByGameId === 'object'
            ? config.collectionsByGameId
            : {};
        var destUrl = resolveCollectionUrl(gid, colMap, btn);
        var domIds = uniqueGameIdsFromDom();
        var hasHomeGrid = domIds.indexOf(gid) >= 0;

        if (isThemeEditor()) {
          designPreviewGame = gid;
        }

        if (isHomepage) {
          if (hasHomeGrid) {
            setActiveOnDocument(gid, storageKey);
            return;
          }
          /* No grid on homepage for this game → open its collection (needs Theme template: game). */
          if (destUrl) {
            try {
              localStorage.setItem(storageKey, gid);
            } catch (e) {}
            window.location.href = destUrl;
          }
          return;
        }

        setActiveOnDocument(gid, storageKey);

        if (onCollections && destUrl) {
          window.location.href = destUrl;
          return;
        }

        if (!isHomepage) {
          window.location.href = destUrl || '/';
        }
      });

      panel.addEventListener('keydown', function (e) {
        var opts = [];
        panel.querySelectorAll('[data-game-switcher-pick][role="option"]').forEach(function (b) {
          opts.push(b);
        });
        if (!opts.length) return;
        var active = document.activeElement;
        var idx = opts.indexOf(active);
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          idx = (idx + 1 + opts.length) % opts.length;
          opts[idx].focus();
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          idx = idx <= 0 ? opts.length - 1 : idx - 1;
          opts[idx].focus();
        } else if (e.key === 'Enter' || e.key === ' ') {
          if (active && active.getAttribute('role') === 'option' && root.contains(active)) {
            e.preventDefault();
            active.click();
          }
        } else if (e.key === 'Escape') {
          closeDetails(root);
          if (summary) summary.focus();
        }
      });
    }

    applyUi();

    document.addEventListener('gameSwitcherActiveChange', applyUi, false);
  }

  function boot() {
    var discovered = discoverGamesFromPage();
    var roots = document.querySelectorAll('[data-game-switcher-root]');

    var merged = {
      storageKey: DEFAULT_KEY,
      defaultGame: 'monopoly-go',
      games: discovered.games,
      collectionsByGameId: discovered.collectionsByGameId,
    };

    for (var r = 0; r < roots.length; r++) {
      var jid = roots[r].getAttribute('data-game-switcher-json-id') || '';
      if (!jid) continue;
      var el = document.getElementById(jid);
      var p = el ? safeJsonParse(el.textContent || '{}', jid) : null;
      if (!p) continue;
      if (p.storageKey) merged.storageKey = String(p.storageKey);
      if (p.defaultGame != null) merged.defaultGame = String(p.defaultGame).trim();
      merged.games = mergeGameLists(p.games, merged.games);
      merged.collectionsByGameId = mergeCollectionMaps(p.collectionsByGameId, merged.collectionsByGameId);
    }

    if (!merged.games.length) {
      merged.games = discovered.games;
    }
    merged.collectionsByGameId = mergeCollectionMaps(merged.collectionsByGameId, discovered.collectionsByGameId);

    reconcile(merged.storageKey, merged.defaultGame);

    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      var myJid = root.getAttribute('data-game-switcher-json-id') || '';
      var myCfg = Object.assign({}, merged);
      if (myJid) {
        var jel = document.getElementById(myJid);
        var parsed = jel ? safeJsonParse(jel.textContent || '{}', myJid) : null;
        if (parsed) {
          if (parsed.storageKey) myCfg.storageKey = String(parsed.storageKey);
          if (parsed.defaultGame != null) myCfg.defaultGame = String(parsed.defaultGame).trim();
          myCfg.games = mergeGameLists(parsed.games, merged.games);
          myCfg.collectionsByGameId = mergeCollectionMaps(parsed.collectionsByGameId, merged.collectionsByGameId);
        }
      }
      initRoot(root, myCfg);
    }

    if (!roots.length && merged.games.length) {
      applyGameVisibility((document.documentElement.getAttribute('data-active-game') || '').trim());
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function () {
    designPreviewGame = null;
    boot();
  });

  document.addEventListener('shopify:section:select', resetDesignPreview);
  document.addEventListener('shopify:block:select', resetDesignPreview);
})();
